import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { IconButton } from '../../base-components';

interface Props<F extends FieldValues> {
    name: Path<F>;
    control: Control<F>;
    children: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    size?: 'small' | 'medium';
}

const FormIconButton = <F extends FieldValues>(props: Props<F>) => {
    const { name, control, children, onClick, disabled, size } = props;

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <IconButton
                    {...field}
                    size={size}
                    onClick={() => {
                        field.onChange(!field.value);
                        onClick?.();
                    }}
                    disabled={disabled}
                >
                    {children}
                </IconButton>
            )}
        />
    );
};

export default FormIconButton;
